module.exports = __webpack_public_path__ + "static/media/RIB-Min.9ac97268.jpg";